import { createContext } from 'react';
export const MultiImageSelectContext = createContext({});